import { apiEndpoints } from "@/helpers";
import { Form, Input, Select } from "antd";
import { useIntl } from "react-intl";
import { FormFieldContainer } from "./styled";

export const AutoCompleteEditFormField = () => {
  const intl = useIntl();

  return (
    <FormFieldContainer>
      <Form.Item
        name={["property", "label", "fallback"]}
        label={intl.formatMessage({ id: "newFormField.fieldLabel" })}
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: "newFormField.fieldLabelRequired",
            }),
          },
        ]}
      >
        <Input className="viper-form-element-max-width" />
      </Form.Item>
      <Form.Item
        name={["property", "placeholder", "fallback"]}
        label={intl.formatMessage({ id: "newFormField.placeholder" })}
      >
        <Input className="viper-form-element-max-width" />
      </Form.Item>
      <Form.Item
        name={["property", "requiredValidationText", "fallback"]}
        label={intl.formatMessage({ id: "newFormField.validationErrorText" })}
      >
        <Input className="viper-form-element-max-width" />
      </Form.Item>
      <Form.Item
        name={["property", "url"]}
        label={intl.formatMessage({ id: "newFormField.endpoint" })}
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: "newFormField.endpointRequired",
            }),
          },
        ]}
      >
        <Select style={{ maxWidth: 500 }}>
          <Select.Option value={apiEndpoints.users.suggestions}>
            {intl.formatMessage({ id: "newFormField.endpoint_users" })}
          </Select.Option>
          <Select.Option value={apiEndpoints.departments.suggestions}>
            {intl.formatMessage({ id: "newFormField.endpoint_departments" })}
          </Select.Option>
        </Select>
      </Form.Item>
    </FormFieldContainer>
  );
};
